import React from 'react';
import { Select } from '@sainsburys-tech/bolt';

var VariantDropdown = function VariantDropdown(_ref) {
  var currentPartNumber = _ref.currentPartNumber,
      variants = _ref.variants,
      type = _ref.type,
      index = _ref.index,
      _ref$colSize = _ref.colSize,
      colSize = _ref$colSize === void 0 ? 12 : _ref$colSize,
      dataTest = _ref['data-test'],
      callback = _ref.callback;
  return /*#__PURE__*/React.createElement("div", {
    className: "xs-".concat(colSize, "--none"),
    style: {
      paddingLeft: index > 0 ? '5px' : '0px'
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "capitalize",
    "data-test": "".concat(dataTest, "-type")
  }, type), /*#__PURE__*/React.createElement(Select, {
    value: currentPartNumber,
    options: variants.map(function (variant) {
      return {
        title: variant.title || variant.value,
        value: variant.partNumber
      };
    }),
    onChange: function onChange(event) {
      return callback(event.target.value);
    },
    "data-test": "".concat(dataTest, "-select")
  }));
};

export default VariantDropdown;